// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"0259e9e2","73":"16b6a0c2","269":"c85e9c39","509":"840999a8","900":"31732b75"}[chunkId] + ".chunk.css";
};